export default __webpack_public_path__ + "static/media/files-glery1.13421697.jpg";